import { useSelectedLayoutSegments } from 'next/navigation';

import type { NavItems } from '@/types/nav';

export const useNavItemsComposer = () => {
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const pathSegments = selectedLayoutSegments.map(segment => `/${segment}`);

	return (navItems: NavItems) => {
		return navItems.map(item => ({
			...item,
			selected: pathSegments.includes(item.routePrefix ?? item.href)
		}));
	};
};